import React from 'react'

export default () => <div style={{ flex: 1 }} />
